import React, { useEffect } from "react" 
import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  CardSubtitle,
  Table,
  InputGroup,
} from "reactstrap"
import { addWard, getRegion } from "service/api"


const defaultValue = {
  ward: "",
  region: ""
}

const AddWard = () => {
  const [ward, setData] = useState(defaultValue);
  const [errors, setErrors] = useState({});
  const [reg, setReg] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
      document.title = "Ward | Add Ward";
    }, []);

  useEffect(() => {
    const fetchRegions = async () => {
      try {
        const Reg = await getRegion();
        setReg(Reg.data);
      } catch (error) {
        console.error("Error fetching regions:", error);
      }
    };
    fetchRegions();
  }, []);

  const onValueChange = (e) => {
    const { name, value } = e.target;
    setData({ ...ward, [name]: value });

    // clear error on input
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validate = () => {
    let formErrors = {};
    if (!ward.region) formErrors.region = "Region is required";
    if (!ward.ward.trim()) formErrors.ward = "Ward name is required";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleAddWard = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      await addWard(ward);
      navigate("/ward");
      toast.success("Ward saved successfully.", {
        position: "top-center",
        autoClose: 1500,
      });
    } catch (error) {
      toast.error("Failed to save ward.");
      console.error(error);
    }
  };

    
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="page-title"> Add Ward </h4>
            <Link to="/ward" className="btn btn-danger">Ward</Link>
          </div>
          <Row>
            <Card>
              <CardBody>
                <Form>
                  <Row>
                    <Col lg={3}>
                        <div className="mb-3">
                        <Label htmlFor="formrow-login">Region<span style={{ color: "red" }}>*</span>
</Label>
                        <select
                            name="region"
                             className={`form-control ${errors.region ? "is-invalid" : ""}`}
                            onChange={e => onValueChange(e)}
                        >
                            {reg.length > 0 ? (
                            <>
                                <option defaultValue>Select</option>
                                {reg.map(s => (
                                <option key={s._id} value={s._id}>
                                    {s.region}
                                </option>
                                ))}
                            </>
                            ) : (
                            <option disabled>No Region Available</option>
                            )}
                        </select>
                         {errors.region && (
                          <div className="invalid-feedback">{errors.region}</div>
                        )}
                        </div>
                    </Col>
                    <Col lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">Ward<span style={{ color: "red" }}>*</span>
</Label>
                        <Input
                          type="text"
                         className={`form-control ${errors.ward ? "is-invalid" : ""}`}
                          name="ward"
                          Placeholder="Enter Ward"
                          onChange={e => onValueChange(e)}
                        />
                        {errors.ward && (
                          <div className="invalid-feedback">{errors.ward}</div>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <div>
                    <button className="btn btn-primary w-md mx-2" onClick={(e) => handleAddWard(e)}>
                        Save
                    </button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default  AddWard;
